import { translatePath, untranslatePath, type NonEnLang } from '@shared/route-slugs';
import { getLocalizedSlug, resolveLocalizedSlug } from '@shared/localized-slugs';
import { LANG_CONFIGS, NON_EN_LANG_CODES, LOCALE_BY_CODE, type SiteLang } from '@shared/languages';
export type { SiteLang } from '@shared/languages';

export function locale5(lang: string): string {
  return LOCALE_BY_CODE[lang as SiteLang] ?? 'en-GB';
}

const LANG_PREFIXES: SiteLang[] = NON_EN_LANG_CODES as SiteLang[];

export function getPathLanguage(pathname: string): SiteLang {
  for (const lang of LANG_PREFIXES) {
    if (pathname === `/${lang}` || pathname.startsWith(`/${lang}/`)) return lang;
  }
  return 'en';
}

const GUIDE_PATH_SEGMENTS: Partial<Record<NonEnLang, string>> = {
  de: 'reisefuehrer',
  fr: 'guides-voyage',
  it: 'guide-viaggio',
  nl: 'reisgidsen',
  hr: 'vodici',
  pl: 'przewodniki',
};

export function localePath(path: string, lang: SiteLang): string {
  if (lang === 'en') return path;
  const translated = translatePath(path, lang as NonEnLang);
  const parts = translated.split('/').filter(Boolean);
  if (parts.length >= 2 && parts[0] === GUIDE_PATH_SEGMENTS[lang as NonEnLang]) {
    const localSlug = getLocalizedSlug('guide', parts[1], lang as NonEnLang);
    if (localSlug !== parts[1]) {
      parts[1] = localSlug;
      return `/${lang}/` + parts.join('/');
    }
  }
  return translated === '/' ? `/${lang}` : `/${lang}${translated}`;
}

export function stripLangPrefix(pathname: string): string {
  for (const lang of LANG_PREFIXES) {
    if (pathname === `/${lang}`) return '/';
    if (pathname.startsWith(`/${lang}/`)) {
      const withoutLang = pathname.slice(lang.length + 1);
      const unTranslated = untranslatePath(withoutLang, lang as NonEnLang);
      const parts = unTranslated.split('/').filter(Boolean);
      if (parts.length >= 2 && parts[0] === 'guides') {
        const engSlug = resolveLocalizedSlug('guide', parts[1]);
        if (engSlug !== parts[1]) {
          parts[1] = engSlug;
          return '/' + parts.join('/');
        }
      }
      return unTranslated;
    }
  }
  return pathname;
}

export function switchLangPath(pathname: string, targetLang: SiteLang): string {
  const stripped = stripLangPrefix(pathname);
  return localePath(stripped, targetLang);
}

export function toggleLanguagePath(pathname: string): string {
  if (pathname === '/de' || pathname.startsWith('/de/')) {
    const stripped = stripLangPrefix(pathname);
    return stripped;
  }
  return pathname === '/' ? '/de' : localePath(pathname, 'de');
}

export { LANG_CONFIGS };
